<template>
  <div>
    <section class="hero is-primary is-large"
      :style="backgroundStyle">
      <button
        class="button"
        v-if="user.action === 'nothing'"
        @click="disconnect">
        {{ $t('buttons.disconnect') }}
      </button>
      <!-- Hero content: will be in the middle -->
      <div class="hero-body">
        <div class="columns">
          <div class="column is-one-fifth">
            <div class="media-left">
              <figure class="image is-128x128">
                <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder image">
              </figure>
            </div>
          </div>
          <div class="column">
            <h1 class="title">
              {{ this.$route.params.username }} <button class="button" v-if="user.action !== 'nothing'" @click="socialize">{{ user.action }}</button>
            </h1>
            <h2 class="subtitle">
              {{ user.currentLevel.rank }}
            </h2>
            Lvl {{ user.currentLevel.level }} ({{ user.xp }}/{{ user.currentLevel.highXpThreshold }}XP)
            <progress class="progress" :value="levelPercentage" max="100">{{ levelPercentage }}%</progress>
            <!--span class="tag">Master</span-->
            <!--span class="tag">Serial Smasher</span-->
            <!--span class="tag">Status-quo aficionado</span-->
          </div>
        </div>
      </div>

      <!-- Hero footer: will stick at the bottom -->
      <!--div class="hero-foot">
        <nav class="tabs is-boxed is-fullwidth">
          <div class="container">
            <ul>
              <li class="is-active"><a>Overview</a></li>
              <li><a>Stats</a></li>
              <li><a>Matchs</a></li>
              <li><a>Tournaments</a></li>
            </ul>
          </div>
        </nav>
      </div-->
    </section>
  </div>
</template>

<script>
import { EventBus } from '@/services/bus'
import ApiUsers from '@/api/users'
export default {
  data () {
    return {
      user: {
        xp: 0,
        color1: 'FFFFFF',
        color2: 'FFFFFF',
        currentLevel: {
          level: 0,
          rank: '',
          highXpThreshold: 1
        },
        action: 'nothing'
      }
    }
  },
  computed: {
    levelPercentage () {
      return (this.user.xp / this.user.currentLevel.highXpThreshold * 100)
    },
    backgroundStyle () {
      return {
        backgroundImage: 'linear-gradient(141deg, #' + this.user.color1 + ', #' + this.user.color2 + ')'
      }
    }
  },
  methods: {
    socialize () {
      if (this.user.action === 'follow') {
        ApiUsers.post.follow({userId: this.user.id}).then(response => {
          this.user.action = 'unfollow'
        })
      } else {
        ApiUsers.post.unfollow({userId: this.user.id}).then(response => {
          this.user.action = 'follow'
        })
      }
    },
    disconnect () {
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('username')
      this.$router.push({name: 'Home'})
      EventBus.$emit('isLoggedIn', false)
    }
  },
  created () {
    ApiUsers.get.byUsername(this.$route.params.username).then(response => {
      this.user = response.body
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/PageUser.vue